export default __webpack_public_path__ + "static/yelpCamp-1201dda8673c74847251f25ecaef1a5a.png";